(function(root){
  // ---- MORE RIM GROUP PURE BLOCK START ----
  // One card per wheel (brand + model + finish), with the size/offset and centre bore as
  // options — the same shape as a Shopify rim product. A title with no model word stays its own card.
  var RG_FINISH = { black:1, blk:1, mblk:1, mbk:1, sblk:1, mchl:1, machined:1, mach:1, chrome:1,
    bronze:1, brz:1, bronz:1, silver:1, silv:1, slv:1, grey:1, gray:1, gunmetal:1, graphite:1,
    white:1, wht:1, gold:1, gd:1, red:1, blue:1, blu:1, titanium:1, matte:1, gloss:1, satin:1,
    metallic:1, milled:1, flat:1, lip:1, face:1, tint:1, dark:1, light:1, polished:1, painted:1, anthracite:1 };
  function rgTokens(s) {
    return String(s || '').toLowerCase().replace(/[×✕]/g, 'x').replace(/(\d+)\.0+(?=\D|$)/g, '$1').match(/[a-z0-9]+/g) || [];
  }
  function rgModelKey(brand, title) {
    var drop = { x: 1, r: 1, zr: 1 };
    rgTokens(brand).forEach(function (t) { drop[t] = 1; });
    return rgTokens(title).filter(function (t) { return !/^\d/.test(t) && !drop[t]; }).join(' ');
  }
  function rgGroupable(key) {
    var parts = String(key || '').split(' '), i;
    for (i = 0; i < parts.length; i++) if (parts[i] && !RG_FINISH[parts[i]] && parts[i].length > 1) return true;
    return false;
  }
  function rgGroupKey(it) {
    var mk = rgModelKey(it && it.brand, it && it.title);
    if (!rgGroupable(mk)) return 'one\n' + ((it && (it.id || it.part)) || '');
    // v3 (RT audit 2026-10-09): the model number is part of the wheel. rgModelKey drops every token that
    // starts with a digit, so REPLICA 327 / 414, SF-2 / SF-5 and VRD-701 / 705 shared one card. Key on the
    // short title's words instead (spec codes and the size already gone), minus the brand words.
    var drop = { x: 1, r: 1, zr: 1 };
    rgTokens(it && it.brand).forEach(function (t) { drop[t] = 1; });
    var k2 = rgTokens(rgShortTitle(it, false)).filter(function (t) { return !drop[t]; }).join(' ');
    return String((it && it.brand) || '').toLowerCase() + '\n' + (k2 || mk);
  }
  function rgHeading(it) {
    var t = String((it && it.title) || '');
    t = t.replace(/\b\d{1,2}\s*[x×]\s*\d{2,3}(?:\.\d+)?\s*mm\b/gi, ' ');
    t = t.replace(/\b\d{2,3}(?:\.\d+)?\s*mm\b/gi, ' ');
    t = t.replace(/(^|\s)[+-]\d{1,3}(?:\.\d+)?(?=\s|$)/g, ' ');
    t = t.replace(/\b\d{1,2}(?:\.\d+)?\s*[x×]\s*\d{1,2}(?:\.\d+)?\b/gi, ' ');
    t = t.replace(/\s+/g, ' ').trim().replace(/^\/\s*|\s*\/$/g, '').trim();
    return t || String((it && it.title) || '');
  }
  function rgBits(it) {
    var src = (it && (it.size || it.title)) || '';
    var m = /(\d{1,2}(?:\.\d+)?)\s*[x×]\s*(\d{1,2}(?:\.\d+)?)/i.exec(src);
    var dia = m ? +m[1] : null, wid = m ? +m[2] : null;
    var off = it && typeof it.offset === 'number' && isFinite(it.offset) ? it.offset : null;
    var size = it && it.size ? String(it.size) : 'Size';
    if (dia != null && wid != null) {
      size = dia + 'x' + wid;
      if (off != null) size += ' ' + (off < 0 ? String(off) : '+' + off) + 'mm';
    }
    var boreN = it && it.bore != null && it.bore !== '' ? parseFloat(it.bore) : NaN;
    return { dia: dia, wid: wid, off: off, size: size, bore: isFinite(boreN) ? String(boreN) : '', bolt: it && it.bolt ? String(it.bolt) : '' };
  }
  function rgCmp(a, b) {
    var A = rgBits(a), B = rgBits(b);
    return (A.dia || 0) - (B.dia || 0) || (A.wid || 0) - (B.wid || 0)
      || (A.off == null ? 999 : A.off) - (B.off == null ? 999 : B.off)
      || (parseFloat(A.bore) || 0) - (parseFloat(B.bore) || 0)
      || String(a.part || '').localeCompare(String(b.part || ''));
  }
  function rgPartText(it) {
    var p = String(it && it.part != null ? it.part : '').replace(/\s+/g, ' ').trim();
    return p ? 'Part # ' + p : '';
  }
  function rgUniq(arr) {
    var out = [], seen = {}, i;
    for (i = 0; i < arr.length; i++) if (arr[i] !== '' && arr[i] != null && !seen[arr[i]]) { seen[arr[i]] = 1; out.push(arr[i]); }
    return out;
  }
  function rgGroups(items) {
    var order = [], map = {}, i, it, k, g;
    for (i = 0; i < (items || []).length; i++) {
      it = items[i]; if (!it) continue;
      k = rgGroupKey(it); g = map[k];
      if (!g) { g = map[k] = { key: k, items: [] }; order.push(g); }
      g.items.push(it);
    }
    for (i = 0; i < order.length; i++) order[i].items.sort(rgCmp);
    return order;
  }
  // v2: one pick per axis, in this order: bolt -> diameter -> width -> offset -> bore. Each axis lists
  // every value the group has (axis shown only with 2+); a value with no part under the picks above
  // it is left out of `here`, so the card shows it disabled. Offsets sort most negative -> most positive.
  function rgChoose(items, want) {
    want = want || {};
    var bits = (items || []).slice().sort(rgCmp).map(function (it) { var b = rgBits(it); if (b.off == null) b.off = ''; return { it: it, b: b }; });
    function num(a, b) { return a === '' ? (b === '' ? 0 : 1) : b === '' ? -1 : a - b; }
    function vals(pool, key) { var values = pool.map(function (x) { return x.b[key]; }); var out = rgUniq(values); if ((key === 'off' || key === 'bore') && values.indexOf('') !== -1) out.push(''); return out; }
    function step(pool, key, wanted, sortFn) {
      var all = vals(bits, key), here = vals(pool, key);
      // Missing fitment is not a customer option. Keep the whole pool so Part # still
      // reaches every wheel; the Selected box shows only that part's verified specs.
      if ((key === 'off' || key === 'bore') && all.indexOf('') !== -1)
        return { all: [], here: [], pick: null, pool: pool };
      if (sortFn) { all.sort(sortFn); here.sort(sortFn); }
      var pick = wanted != null && here.indexOf(wanted) !== -1 ? wanted : (here.length ? here[0] : null);
      var next = pick == null ? pool : pool.filter(function (x) { return x.b[key] === pick; });
      return { all: all, here: here, pick: pick, pool: next.length ? next : pool };
    }
    var sb = step(bits, 'bolt', want.bolt || null);
    var sd = step(sb.pool, 'dia', typeof want.dia === 'number' ? want.dia : null, num);
    var sw = step(sd.pool, 'wid', typeof want.wid === 'number' ? want.wid : null, num);
    var so = step(sw.pool, 'off', typeof want.off === 'number' || want.off === '' ? want.off : null, num);
    var sc = step(so.pool, 'bore', want.bore == null ? null : want.bore, num);
    // v3: two parts with the same bolt, size, offset and bore (duplicate supplier listings, e.g.
    // GT42212448180BML / GT92212818044GBML) get a Part # pick so the second one can be chosen and quoted.
    var twins = sc.pool.map(function (x) { return String(x.it.part || ''); }).filter(function (v) { return v; });
    var sp = { all: twins.length > 1 ? twins : [], here: twins.length > 1 ? twins : [], pick: null };
    if (sp.all.length) sp.pick = want.part && sp.here.indexOf(want.part) !== -1 ? want.part : sp.here[0];
    var picked = (sp.pick ? sc.pool.filter(function (x) { return String(x.it.part || '') === sp.pick; })[0] : null) || sc.pool[0] || bits[0];
    var pb = picked ? picked.b : {};
    return {
      item: picked ? picked.it : null,
      bolt: sb.pick || '', dia: sd.pick, wid: sw.pick, off: so.pick, bore: sc.pick || '', part: sp.pick || '',
      size: pb.dia != null && pb.wid != null ? pb.dia + 'x' + pb.wid : '',
      axes: [
        { key: 'bolt', label: 'Bolt pattern', all: sb.all, here: sb.here, pick: sb.pick },
        { key: 'dia', label: 'Diameter', all: sd.all, here: sd.here, pick: sd.pick },
        { key: 'wid', label: 'Width', all: sw.all, here: sw.here, pick: sw.pick },
        { key: 'off', label: 'Offset', all: so.all, here: so.here, pick: so.pick },
        { key: 'bore', label: 'Centre bore', all: sc.all, here: sc.here, pick: sc.pick },
        { key: 'part', label: 'Part #', all: sp.all, here: sp.here, pick: sp.pick }
      ]
    };
  }
  function rgAxisText(key, v) {
    if (v === '' && (key === 'off' || key === 'bore')) return '';
    if (key === 'dia' || key === 'wid') return v + '"';
    if (key === 'off') return rgOffsetText(v);
    if (key === 'bore') return v + ' mm';
    return String(v);
  }
  // The "Selected" rows for a grouped card: what the Part #, price and quote are for. `same` marks a
  // value every part in the group shares (shown plain).
  function rgSelRows(it, items) {
    var b = rgBits(it), rows = [];
    var all = (items || []).map(rgBits);
    function same(fn) { var v = fn(b); return all.every(function (x) { return fn(x) === v; }); }
    if (b.dia != null && b.wid != null) rows.push(['Size', b.dia + 'x' + b.wid, same(function (x) { return x.dia + 'x' + x.wid; })]);
    if (b.bolt) rows.push(['Bolt pattern', b.bolt, same(function (x) { return x.bolt; })]);
    if (b.off != null) rows.push(['Offset', rgOffsetText(b.off), same(function (x) { return x.off; })]);
    if (b.bore) rows.push(['Centre bore', b.bore + ' mm', same(function (x) { return x.bore; })]);
    var p = String(it && it.part != null ? it.part : '').replace(/\s+/g, ' ').trim();
    if (p) rows.push(['Part #', p, (items || []).length < 2]);
    return rows;
  }
  // DRAFT 2026-10-08 (RT: "keep titles short; offset and centre bore as labeled fields").
  // Short card title = the supplier title's words with every spec code taken out
  // (bolt "8-165.1", "6X135/5.5", slash "28/117", signed offset "-19", "+40", "ET129",
  // "CB124.1", "106.1", "-19MM", "125.2MM", "1.52BS"), the size written once as "16x6.5".
  // Words and finish codes stay where the supplier put them. A bare whole number before
  // the size is a model number (ION TYPE 143, CALI PURGE 9114) unless it is the bore or offset.
  function rgSpecTok(t) {
    var w = String(t || '').replace(/[;,]+$/, '');
    if (!w) return true;
    if (/^(?:et|cb)[+-]?\d/i.test(w)) return true;
    if (/^[+-]\d/.test(w)) return true;
    if (/^\d[\d.]*(?:mm|bs?)$/i.test(w)) return true;
    if (/^\d[\d.]*[x×\/-][\d.x×\/-]*(?:mm)?$/i.test(w)) return true;
    if (/^\d+\.\d+$/.test(w)) return true;
    return false;
  }
  function rgDisplayName(title, brand) {
    var s = String(title || '');
    if (/^cali off-road$/i.test(brand || '')) s = s.replace(/^CALI OFF[ -]ROAD (?=(?:EVOKE 9119|SUMMIT 9110)\b)/i, 'Cali ');
    if (/^twisted off-road$/i.test(brand || '')) s = s.replace(/^TWISTED OFF[ -]ROAD (?=TW[123]\b)/i, '');
    s = s.replace(/\bART REPLICA REPLICA\b/gi, 'ART Replica');
    var codes = /^(?:ART|ION|RTX|RSSW|GT|HD|XD|XXR|US|OE|OEM|MBG|BD|MCH|CC|SFCC|MB|MBK|MBM|BM|GB|GBM|GBML|MBML|BB|BC|BML|BMF|GBMF|DDT|UDT|BLK|MBLK|SBLK|BRZ|SLV|SILV|POL|CHR|CHRM|ANT|RBL|REPL|FRT|RH|LH|CNC|ATV|UTV|NBL|NLQ|GBLK|GBLKMILL|BLD|ABM|KBL|NLK|BRNZ|BNZ|BZBR|ZDB|GLD|GRN|GNMTL|GMTL|MGMTL|GRY|ANTH|GDB|NGD|MCHL|MACH|MILL|MIL|BRSH|BRU|CRM|MBQ|MSL|SLVR|GSLV|SIL|MAT|MET|SAT|NBD|MBT)$/;
    return s.split(/(\s+)/).map(function (w) {
      if (/\d/.test(w) || codes.test(w) || !/[A-Z]/.test(w) || /[a-z]/.test(w)) return w;
      return w.replace(/[A-Z]+/g, function (part) { return codes.test(part) || part.length < 3 ? part : part[0] + part.slice(1).toLowerCase(); });
    }).join('');
  }
  function rgShortTitle(it, withSize) {
    var raw = String((it && it.title) || '').replace(/[×✕]/g, 'x').replace(/\s+/g, ' ').trim();
    if (!raw) return '';
    var b = rgBits(it);
    var sizeTxt = b.dia != null && b.wid != null ? b.dia + 'x' + b.wid : '';
    var boreN = parseFloat(b.bore), offN = b.off;
    var toks = raw.split(' '), out = [], drop = [], sizeAt = -1, i, t, w, m;
    for (i = 0; i < toks.length; i++) {
      t = toks[i]; w = t.replace(/[;,]+$/, '');
      m = /^(\d{1,2}(?:\.\d+)?)x(\d{1,2}(?:\.\d+)?)$/i.exec(w);
      if (sizeAt === -1 && m && b.dia != null && +m[1] === b.dia && +m[2] === b.wid) { sizeAt = i; drop[i] = 'size'; continue; }
      if (rgSpecTok(t)) { drop[i] = 'spec'; continue; }
      if (/^\d+$/.test(w)) {
        var n = +w;
        if ((isFinite(boreN) && Math.abs(n - boreN) < 1.5) || (offN != null && n === Math.abs(offN))) { drop[i] = 'spec'; continue; }
        if (sizeAt !== -1) { drop[i] = 'spec'; continue; }
      }
    }
    for (i = 0; i < toks.length; i++) {
      if (drop[i] === 'size') { if (withSize && sizeTxt) out.push(sizeTxt); continue; }
      if (drop[i]) continue;
      // A lone "/" between two spec codes ("6x135 / 139.7mm") goes with them; "BRZ / DRK" stays.
      if (toks[i] === '/' && (drop[i - 1] || drop[i + 1] || i === 0 || i === toks.length - 1)) continue;
      out.push(toks[i]);
    }
    if (withSize && sizeTxt && sizeAt === -1) out.push(sizeTxt);
    var s = out.join(' ').replace(/\s+/g, ' ').replace(/^[\/;,\s]+|[\/;,\s]+$/g, '').trim();
    if (!/[a-z]/i.test(s)) s = rgHeading(it);
    return rgDisplayName(s, it && it.brand);
  }
  function rgOffsetText(off) {
    if (off == null || typeof off !== 'number' || !isFinite(off)) return '';
    return (off > 0 ? '+' : '') + off + ' mm';
  }
  // Labeled rows for the item on the card. Blank values are skipped, never guessed.
  function rgSpecRows(it, skip) {
    skip = skip || {};
    var b = rgBits(it), rows = [];
    if (b.bolt && !skip.bolt) rows.push(['Bolt pattern', b.bolt]);
    if (b.off != null && !skip.offset) rows.push(['Offset', rgOffsetText(b.off)]);
    if (b.bore && !skip.bore) rows.push(['Centre bore', b.bore + ' mm']);
    return rows;
  }
  // ---- MORE RIM GROUP PURE BLOCK END ----
var api={rgBits,rgCmp,rgGroups,rgGroupKey,rgChoose,rgShortTitle,rgSelRows,rgSpecRows,rgAxisText};if(typeof module==='object'&&module.exports)module.exports=api;else root.RTRimGrouping=api;
})(typeof globalThis==='object'?globalThis:this);
